import { RootPage } from '../page';
import $api from '../../api';

class SetPasswordView extends RootPage {
    constructor() {
        super();

        this.password = ko.observable().extend({ required: true });
        this.token = ko.observable();

        this.signInProblem = ko.observable(false);
    }

    submitSignIn() {
        this.startSubmitting();

        $api.account.setPassword({}, { token: this.token(), newPassword: this.password() }, (resp, a, b) => {
            this.stopSubmitting();

            if (b.status !== 200) {
                this.signInProblem(true);
            } else {
                TRACK_EVENT('Users', 'Set New Password');

                window.location.href = '/';
            }
        });
    }
}

export default SetPasswordView;